import React from 'react';
import { Header } from '../generic/headFoot';
import { SetNewVehStat } from '../lib/db/journeys';
import Menu from '../components/menu/index';
import { LoadingScreen } from '../generic/input';
import { Col, Row, Grid, Alert } from 'react-bootstrap/lib';
import { getVidArray, _setNewUrl } from '../lib/common';
import { NOTIF_TYPE, NOTIFICATION_TYPE } from '../lib/enums';
import { GetTriggers } from '../db/triggers';
var WebSocketClient = require('../lib/ws').WebSocketClient;
var IndexedDbClient = require('../db/indexedDbClient').IndexedDbClient;
var Listeners = require('../lib/listeners').Listeners;

export default class Authorized extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicles: [],
      errMsg: "",
      isLoading: true
    }
    this.vehMap = {};
    this.triggersMap = {};
    if (!global.gWebSocket) {
      global.gWebSocket = new WebSocketClient();
    }

    if (!global.listeners) {
      global.listeners = new Listeners();
    }
    this.eventsObj = {
      "WS_ONLINE_STATE": global.listeners.onWsReady,
      "BIKES": this.onBikes,
      "VEHSTAT": this.onChangeVehicleStat,
      "GET_EVENTS_BY_LIMIT": global.listeners.onGetEvents,
      "ON_TIMELINE_EVENTS": global.listeners.timelineEvents,
      "LOCATION_EVENTS": global.listeners.onLocationEvents,
      "PSEUDO_PROCESSED": global.listeners.saveEvents,
      "GET_LOC_FOR_DAY": global.listeners.getLocForDay,
      "REMOVE_LOC_LISTENER": this.removeLocEventListener,
      "NEW_NOTIF": this.onLiveNotif
    };
  }

  componentWillMount() {
    Object.keys(this.eventsObj).forEach(e => {
      global.EE.addEventListener(global.EE.EVENT_TYPES[e], this.eventsObj[e]);
    });
  }

  componentWillUnmount() {
    Object.keys(this.eventsObj).forEach(e => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES[e], this.eventsObj[e]);
    });
  }

  removeLocEventListener = (remove) => {
    if (remove) global.EE.removeEventListener(global.EE.EVENT_TYPES.LOCATION_EVENTS, global.listeners.onLocationEvents);
    else global.EE.addEventListener(global.EE.EVENT_TYPES.LOCATION_EVENTS, global.listeners.onLocationEvents);
  }

  onLiveNotif = (evt) => {
    var self = this;
    if (evt.t && (evt.t === NOTIF_TYPE.SPEED_ALERT || evt.t === NOTIF_TYPE.GEO_FENCE)) {
      var veh = this.vehMap[evt.vid];
      var notifText = this.NotificationText({ veh, evt });

      if (notifText) {
        Notification.requestPermission().then(function (result) {
          self.showNotification(notifText);
          if (result === 'denied') {
            console.log('Permission wasn\'t granted. Allow a retry.');
            return;
          }
          if (result === 'default') {
            console.log('The permission request was dismissed.');
            return;
          }
        });
      }
    }
  }

  NotificationText(info) {
    var textObj = {
      uid: info.evt.uid,
      vid: info.evt.vid,
      wts: info.evt.wts,
      ts: info.evt.ts,
      t: info.evt.t,
      meta: null
    };

    var vehicle = this.vehicles.find(veh => veh.idx === info.evt.vid)

    var params;
    if (info.evt.t === NOTIF_TYPE.SPEED_ALERT) {
      params = [];
      params.push(info.evt.meta.spd);
      params.push(info.evt.meta.thresh);
    }
    else if (info.evt.t === NOTIF_TYPE.GEO_FENCE) {
      params = [];
      var pos = info.evt.meta.igf ? "entered" : "exited";
      let title = this.triggersMap[info.evt.meta.tid].title;
      params.push(pos + ' ' + title);
    }


    let template = NOTIFICATION_TYPE.find((n) => n.t === info.evt.t);

    textObj.h = template.nm;
    if (template.en && template.en.length) {
      if(info.evt.t === NOTIF_TYPE.SPEED_ALERT) {
        textObj.msg = info.evt.msg;
      } else {
        var text = this.getLabel(template.en, params);
        textObj.msg = vehicle.reg + " - " + text;
      }
    }
    return textObj;
  }

  getLabel(data, props) {
    if (data) {
      if (data instanceof Array) {
        var str = '';
        props = props.slice(0, data.length - 1);
        data.forEach((el, i) => {
          str = this.appendStr(str, el);
          str = this.appendStr(str, props[i]);
        });
        return str;
      }
      else
        return data;
    }
  }

  appendStr(str, val) {
    var punc = ",.?!";
    if (val && typeof val != "string") val = val.toString();
    var addSpace = !(val && punc.includes(val[0]))
    if (val === undefined) return str;
    if (str.length > 0 && val !== '' && addSpace) str += ' ';
    str += val;
    return str;
  }

  showNotification = (notif) => {
    var self = this;
    var options = {
      body: notif.msg,
      icon: 'https://res.ajjas.com/img/webpush.png',
    }
    var notification = new Notification(notif.h, options);
    notification.onclick = function (event) {
      var newUrl = "/webapptl/notifs?veh=" + notif.vid;
      self.props.router.push(newUrl);
    }
  }

  onChangeVehicleStat = (data) => {
    SetNewVehStat(data, (err, stats) => {
      global.EE.emitEvent(global.EE.EVENT_TYPES.ON_CHANGE_VEHSTAT, err || data);
    });
  }

  onBikes = (vehicles) => {
    var vids = [], obj = {};
    this.vehicles = vehicles;
    if (vehicles && vehicles.length) {
      global.userId = vehicles[0].uid;
      if (this.props.location && this.props.location.query && this.props.location.query.vid) {
        let vidArr = getVidArray(this.props.location.query.vid);
        vehicles.forEach(v => {
          if (vidArr.includes(v.idx)) {
            vids.push(v.idx);
          }
        });
        var newUrl = _setNewUrl(this.props.location, vids);
        this.props.router.replace(newUrl);
      } else vids = vehicles.map((d) => { return (d.idx); });

      if (!global.indexedDbClient) {
        let indexedDbClientInst = new IndexedDbClient(vids, (err) => {
          if (!err) {
            global.indexedDbClient = indexedDbClientInst;
            this.getTrigerList(() => {
              obj.isLoading = false;
              this.setState(obj);
            });
          }
        });
      }

      if (vids && vids.length) {
        global.subVeh = vids;
        this.SendRequest({ a: "subVeh", d: { veh: vids } });
      }
    } else {
      obj.errMsg = "Please install ajjas device to enable this features in website";
      obj.isLoading = false;
      this.setState(obj);
    }
  }

  SendRequest = (data) => {
    global.gWebSocket.SendRequest({ data: data })
  }

  getTrigerList(cb) {
    GetTriggers((err, triggers) => {
      if (err) console.error(err);
      else {
        if (triggers.length) {
          triggers.forEach(tr => {
            this.triggersMap[tr.idx] = tr;
          });
        }
      }
      cb();
    });
  }

  render() {
    return (
      <Grid className="container-width">
        {this.state.isLoading ? <LoadingScreen /> : null}
        <Row>
          <Header location={this.props.location} />
        </Row>
        <Row style={{ width: "100%", height: "100px" }}></Row>
        <Row>
          <Col lg={2} md={3} className="hidden-xs hidden-sm visible-md visible-lg overflowY-auto" style={{ height: "90vh" }}>
            <Menu type="box" {...this.props} />
          </Col>
          <Col lg={10} md={9} sm={12} xs={12}>
            {
              !this.state.errMsg && !this.state.isLoading ?
                this.props.children
                : this.state.errMsg ? <Alert bsStyle="warning">{this.state.errMsg} </Alert> : null
            }
          </Col>
        </Row>
      </Grid>
    )
  }
}